import React, { useState, useEffect } from 'react';
import './index.css';

function CrossMath() {
  const [grid, setGrid] = useState(Array(36).fill(''));
  const [isCreating, setIsCreating] = useState(true);
  const [isCorrect, setIsCorrect] = useState(false);

  const isOperationCell = (index) => {
    const row = Math.floor(index / 6);
    const col = index % 6;
    return (row < 5 && col < 5) && ((row % 2 === 0 && col % 2 === 1) || (row % 2 === 1 && col % 2 === 0));
  };

  const isResultCell = (index) => {
    const row = Math.floor(index / 6);
    const col = index % 6;
    return (row === 5 && col % 2 === 0) || (col === 5 && row % 2 === 0);
  };

  useEffect(() => {
    if (!isCreating) {
      const checkSolution = () => {
        // Check even rows
        for (let row = 0; row < 5; row += 2) {
          let result = parseInt(grid[row * 6]) || 0;
          let operation = '+';
          for (let col = 1; col < 5; col++) {
            if (col % 2 === 1) {
              operation = grid[row * 6 + col];
            } else {
              const num = parseInt(grid[row * 6 + col]) || 0;
              result = operation === '+' ? result + num : result - num;
            }
          }
          if (result !== parseInt(grid[row * 6 + 5])) {
            return false;
          }
        }

        // Check even columns
        for (let col = 0; col < 5; col += 2) {
          let result = parseInt(grid[col]) || 0;
          let operation = '+';
          for (let row = 1; row < 5; row++) {
            if (row % 2 === 1) {
              operation = grid[row * 6 + col];
            } else {
              const num = parseInt(grid[row * 6 + col]) || 0;
              result = operation === '+' ? result + num : result - num;
            }
          }
          if (result !== parseInt(grid[30 + col])) {
            return false;
          }
        }

        return true;
      };
      setIsCorrect(checkSolution());
    }
  }, [grid, isCreating]);

  const handleChange = (index, value) => {
    const newGrid = [...grid];
    newGrid[index] = value;
    setGrid(newGrid);

    if (isCreating) {
      updateResults(newGrid);
    }
  };

  const updateResults = (newGrid) => {
    // Update even row results
    for (let row = 0; row < 5; row += 2) {
      let result = parseInt(newGrid[row * 6]) || 0;
      let operation = '+';
      for (let col = 1; col < 5; col++) {
        if (col % 2 === 1) {
          operation = newGrid[row * 6 + col] || '+';
        } else {
          const num = parseInt(newGrid[row * 6 + col]) || 0;
          result = operation === '+' ? result + num : result - num;
        }
      }
      newGrid[row * 6 + 5] = result.toString();
    }

    // Update even column results
    for (let col = 0; col < 5; col += 2) {
      let result = parseInt(newGrid[col]) || 0;
      let operation = '+';
      for (let row = 1; row < 5; row++) {
        if (row % 2 === 1) {
          operation = newGrid[row * 6 + col] || '+';
        } else {
          const num = parseInt(newGrid[row * 6 + col]) || 0;
          result = operation === '+' ? result + num : result - num;
        }
      }
      newGrid[30 + col] = result.toString();
    }

    setGrid(newGrid);
  };

  const handleCreatePuzzle = () => {
    setIsCreating(false);
    setGrid(grid.map((cell, index) => isResultCell(index) ? cell : ''));
  };

  const handleReset = () => {
    setIsCreating(true);
    setGrid(Array(36).fill(''));
    setIsCorrect(false);
  };

  const renderCell = (index) => {
    if (isOperationCell(index)) {
      return (
        <select
          value={grid[index]}
          onChange={(e) => handleChange(index, e.target.value)}
          disabled={!isCreating}
        >
          <option value=""></option>
          <option value="+">+</option>
          <option value="-">-</option>
        </select>
      );
    } else {
      return (
        <input
          type="number"
          value={grid[index]}
          onChange={(e) => handleChange(index, e.target.value)}
          disabled={!isCreating && isResultCell(index)}
          className={isResultCell(index) ? 'result-cell' : ''}
        />
      );
    }
  };

  return (
    <div className="CrossMathApp">
      {/* <h1>5x5 Cross Math Puzzle Creator and Solver</h1> */}
      <div className="grid-container">
        {Array(36).fill().map((_, index) => (
          <div key={index} className={`grid-item ${isOperationCell(index) ? 'operation-cell' : ''} ${isResultCell(index) ? 'result-cell' : ''}`}>
            {renderCell(index)}
          </div>
        ))}
      </div>
      {/* <button onClick={handleReset}>Reset</button> */}
      {/* {isCreating ? (
        <button onClick={handleCreatePuzzle}>Create Puzzle</button>
      ) : (
        <button onClick={handleReset}>Reset</button>
      )} */}
      {!isCreating && isCorrect && <p className="success-message">Correct! Well done!</p>}
    </div>
  );
}

export default CrossMath;
